import React, { Component } from 'react'
import Link from 'gatsby-link'

import './tooltip.css';
import './header.css';

class HeaderItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipActive: false
    };

    this.toggleTooltip = this.toggleTooltip.bind(this);
  }

  toggleTooltip() {
    this.setState({tooltipActive: !this.state.tooltipActive});
  }

  activateTooltip = () => {
    this.setState({tooltipActive: true})
  };

  deactivateTooltip = () => {
    this.setState({tooltipActive: false})
  };

  renderTooltip() {
    if (!this.props.children) {
      return null;
    }

    return (
      <ToolTip
        hasLightBackground = {this.props.hasLightBackground}
        active= {this.state.tooltipActive}
        children= {this.props.children}>
      </ToolTip>
    )
  }

  handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClick();
  }

  renderItem() {
    let hasLightBackground = this.props.hasLightBackground;
    let borderColorClass = hasLightBackground ? "dark-border" : "light-border";
    let childrenClass = this.props.children ? "" : "without-children";
    let onClick = null;

    if (this.props.onClick != null) {
      onClick = this.handleClick;
    }

    if (this.props.children) {
      onClick = this.toggleTooltip;
    }

    return (
      <a
        href = {this.props.to}
        className={childrenClass + " no-underline " + borderColorClass }
        style={{ cursor: 'pointer', color: (hasLightBackground ? 'black' : 'white')}}
        onClick={onClick}>
        {this.props.title}
      </a>
    );

  }

  render () {
    let tooltip = this.renderTooltip();
    let item = this.renderItem();

    return (
      <div onMouseLeave={this.deactivateTooltip}>
				<div onMouseOver = {this.activateTooltip}>
          {item}
        </div>
        {tooltip}
			</div>
    );
  }
}

class ToolTip extends Component {

  renderChild(child) {
    let borderColorClass = this.props.hasLightBackground ? "light-border" : "dark-border";

    return (
      <Link
        className = {'tooltip__link ' + borderColorClass}
        to = {child.to}
        style = {{
          display: this.props.active ? 'inline-block' : 'none',
          color: this.props.hasLightBackground ? 'white' : 'black',
        }}
      > {child.title}</Link>
    );
  }

  renderChildren() {
    let children = this.props.children.map(
      (child, index) =>
        <div key={index}>
          {this.renderChild(child)}
        </div>
    );

    return (
      <div className={this.props.active ? "" :'hidden'}>
        {children}
      </div>
    );
  }

	render() {
    let borderColor = this.props.active ? (this.props.hasLightBackground ? 'black' : 'white') : 'transparent';

    return (
		   <div className={this.props.active ? "tooltip" :'hidden'} ref="tooltip">
			    <div
           style={{borderBottom:'10px solid ' + borderColor}}
           className={this.props.active ? "tooltip__arrow" :'hidden'}
           ref="arrow">
          </div>

			    <div
           style={{background: this.props.hasLightBackground ? 'black' : 'white'}}
           className={this.props.active ? "tooltip__content" :'hidden'}>
           {this.renderChildren()}
          </div>

			 </div>
		)
	}
}

export default {ToolTip, HeaderItem}



// WEBPACK FOOTER //
// ./src/components/Header/header-item.js